import * as React from 'react';
import { Button, InlineText1 } from '@cian/ui-kit';

import * as styles from './CallButton.css';

interface ICallButtonFieldProps {
  phone: string;
  isOpen: boolean;
  disabled?: boolean;
  onClick(e: React.SyntheticEvent<HTMLButtonElement>): void;
  buttonText?: React.ReactText;
  buttonIcon?: React.ReactElement;
}

export const CallButton: React.FC<ICallButtonFieldProps> = ({
  phone,
  isOpen,
  onClick,
  disabled = false,
  buttonText = 'Показать телефон',
  buttonIcon,
}) => {
  if (isOpen) {
    return (
      <div className={styles['phone']}>
        <InlineText1 color="black_100" fontWeight="700">
          {phone}
        </InlineText1>
      </div>
    );
  }

  return (
    <Button disabled={disabled} size="XS" theme="fill_primary" onClick={onClick} beforeIcon={buttonIcon}>
      {buttonText}
    </Button>
  );
};
